import http from '@gp/utils/httpTS';

export const fetchProjectTechnicalsConditions = (params: {
  id: string;
}): Promise<IPipelineProjectTechnicalConditionsResponse> => {
  return http({ method: 'GET', url: '/api/v1/globalpedia_pc/project/tech/options', params }) as any;
};

export const fetchProjectTechnicals = (params: { id: string }): Promise<IPipelineProjectTechnicalResponse> => {
  return http({ method: 'GET', url: '/api/v1/globalpedia_pc/project/tech/tech_framework', params }) as any;
};

export const editProjectTechnicals = (params: IPipelineProjectTechnicalEditParams): Promise<any> => {
  return http({ method: 'POST', url: '/api/v1/globalpedia_pc/project/tech/tech_framework_edit', data: params }) as any;
};
